import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import useFormInput from '../common/useFormInput';
import TextFieldGroup from '../common/TextFieldGroup';
import TextAreaFieldGroup from '../common/TextAreaFieldGroup';
import registerValidator from '../../validation/register';
import { useFirebase } from 'react-redux-firebase';
import { fbEmail, fbPassword } from '../../config';
import isEmpty from '../../utils/isEmpty';

export default function Landing() {
  const [errors, setErrors] = useState({});
  const [isWaiting, setIsWaiting] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [alertSuccess, setAlertSuccess] = useState(null);

  const name = useFormInput('');
  const email = useFormInput('');
  const message = useFormInput('');
  const firebase = useFirebase();

  function Alert({ alertSuccess }) {
    if (alertSuccess === null) {
      return null;
    }
    if (alertSuccess) {
      return (
        <div
          className="alert alert-success alert-dismissible fade show"
          role="alert"
        >
          Message sent! Thanks for reaching out to me!
          <button
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      );
    }
    return (
      <div
        className="alert alert-warning alert-dismissible fade show"
        role="alert"
      >
        Oops, we got some errors. Please try again later.
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    );
  }

  /* eslint-disable */
  useEffect(() => {
    firebase.auth().onAuthStateChanged(function (user) {
      if (!user) {
        firebase
          .login({
            email: fbEmail,
            password: fbPassword,
          })
          .then()
          .catch();
      }
    });
  }, []);
  /* eslint-enable */

  useEffect(() => {
    if (!isEmpty(errors)) {
      setIsDisabled(false);
      setIsWaiting(false);
    }
  }, [errors]);

  function onSubmit(e) {
    e.preventDefault();
    setErrors({});
    setIsWaiting(true);
    setIsDisabled(true);
    const userInput = {
      name: name.value,
      email: email.value,
      message: message.value,
    };
    const { errors, isValid } = registerValidator(userInput);
    if (!isValid) {
      setErrors(errors);
    } else {
      const addUserInfo = firebase.functions().httpsCallable('addUserInfo');
      addUserInfo(userInput)
        .then((info) => {
          setAlertSuccess(true);
          setIsWaiting(false);
        })
        .catch((err) => {
          setAlertSuccess(false);
          setIsWaiting(false);
          setIsDisabled(false);
        });
    }
  }

  return (
    <div className="landing bg-light row">
      {/* Comment out the text and photo session. Reserved for future needs. */}
      {/* <div className="container col-lg-7">
        <div className="landing-inner container text-dark">
          <div className="row">
            <div className="col">
              <div className="row mt-5 ml-1 align-items-center">
                <p className="lead">Hi! This is Emma.</p>
                <p className="lead">
                  Have data science interview questions? I'm happy to chat with
                  you. Just fill out the form below. I promise you will hear
                  from me shortly!
                </p>
              </div>
            </div>
            <div className="col-lg-2" />
            <div className="col">
              <div className="row">
                <img
                  className="rounded-circle mx-auto"
                  src={require('../../img/headshot.jpg')}
                />
              </div>
              <div className="row mt-3">
                <a
                  className="mx-auto"
                  href="https://www.linkedin.com/in/wzding/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    width="100"
                    src={require('../../img/linkedinLogo.svg')}
                  />
                </a>
              </div>
              <div className="row">
                <p className="lead mx-auto">My blog posts</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <div className="row py-5"></div> */}
      {/* <section className=""> */}
      <div className="container col-lg-7 my-auto">
        <div className="card text-center card-form">
          <div className="card-body">
            <Alert alertSuccess={alertSuccess} />
            <h3>Contact Me</h3>
            <p></p>
            <form data-testid="register-form" onSubmit={onSubmit}>
              <p className='text-left mb-2'>Name *</p>
              <TextFieldGroup
                name="name"
                value={name.value}
                {...name}
                error={errors.name}
              />
              <p className='text-left mb-2'>Email *</p>
              <TextFieldGroup
                name="email"
                value={email.value}
                {...email}
                error={errors.email}
              />
              <p className='text-left mb-2'>Message *</p>
              <TextAreaFieldGroup
                placeholder="What is the biggest challenge in your interview process?"
                name="difficultPart"
                value={message.value}
                {...message}
                error={errors.message}
                rows={5}
                maxLength={500}
              />
              <Button
                type="submit"
                variant="info"
                className="btn btn-warning btn-lg"
                disabled={isDisabled}
                onClick={onSubmit}
              >
                {isWaiting ? 'Submitting...' : 'Submit Form'}
              </Button>
            </form>
          </div>
        </div>
      </div>
      {/* </section> */}
    </div>
  );
}
